// src/data/testimonials.js
export const testimonialsData = [
    {
        id: 1,
        name: "Khalid Hassan Emran",
        position: "Technical Content Writer || SaaS & WordPress",
        company: "Former Colleague at Ryans Computers",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
        text: "I had the pleasure of working with SA Shuvo Sheikh at Ryans Computers. As a highly skilled computer engineer, he consistently demonstrated expertise in areas like hardware troubleshooting, software installation, and network configuration. His commitment to problem-solving and dedication to delivering high-quality solutions were genuinely impressive.",
        rating: 5,
        date: "November 13, 2024"
    },
    {
        id: 2,
        name: "Md. Sujon Mahmud",
        position: "Executive, VAT & Tax",
        company: "Former Colleague",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
        text: "I worked closely with SA Shuvo Sheikh at Ryans Computers. As a highly skilled computer engineer, he consistently demonstrated a deep understanding of hardware troubleshooting, software installation, and network configuration. His ability to quickly diagnose and resolve complex technical issues, combined with his dedication to delivering top-notch solutions, made him a valuable asset to the team.",
        rating: 5,
        date: "October 28, 2024"
    },
    {
        id: 3,
        name: "Rahim Ahmed",
        position: "Business Owner",
        company: "Creative Solutions Ltd.",
        image: "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
        text: "Shuvo transformed our company's IT infrastructure with his exceptional technical skills. His expertise in computer hardware and AI solutions helped us streamline our operations. Professional, knowledgeable, and always delivers beyond expectations!",
        rating: 5,
        date: "January 15, 2024"
    },
    {
        id: 4,
        name: "Fatima Begum",
        position: "Project Manager",
        company: "Tech Innovations BD",
        image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
        text: "Working with Shuvo on our AI implementation project was a game-changer. His understanding of ChatGPT and generative AI helped us automate several business processes. His technical expertise combined with great communication skills makes him an invaluable partner.",
        rating: 5,
        date: "December 5, 2023"
    },
    {
        id: 5,
        name: "Abdul Karim",
        position: "IT Director",
        company: "Global Solutions Inc.",
        image: "https://images.unsplash.com/photo-1517070208541-6ddc4d3efbcb?w=150&h=150&fit=crop&crop=face",
        text: "Shuvo's ability to troubleshoot complex hardware issues is remarkable. He set up our entire office network and provided excellent ongoing support. His certifications in cybersecurity and Google Ads show his commitment to continuous learning.",
        rating: 5,
        date: "February 20, 2024"
    }
];